import gql from 'graphql-tag';

export const CREATE_IMAGE_SLIDERS = gql`
  mutation createImageSliders($urls: [String!]) {
    createImageSliders(urls: $urls) {
      message
    }
  }
`;

export const DELETE_IMAGE_SLIDERS = gql`
  mutation deleteSingleImageSlider($id: String!) {
    deleteSingleImageSlider(id: $id) {
      message
    }
  }
`;

export const ADMIN_VERIFY_USER_ACCOUNT = gql`
  mutation adminApproveUserAccount($userId: Int!) {
    adminApproveUserAccount(userId: $userId) {
      message
    }
  }
`;

export const CREATE_SELLER_PAYMENT = gql`
  mutation sellerPayment($paymentToken: String!) {
    sellerPayment(paymentToken:$paymentToken) {
      message
    }
  }
`;

export const ASSIGN_USER_ROLE = gql`
  mutation adminAssignRole($userId: Int!, $role: String!) {
    adminAssignRole(id: $userId, role: $role) {
      id
      firstname
      lastname
      username
      telephone
      address
      email
    }
  }
`;

export const BLOCK_USER = gql`
  mutation deleteUser($id: Int!) {
    deleteUser(id: $id) {
      message
    }
  }
`;

export const RESTORE_BLOCKED_USER = gql`
  mutation restoreUser($id: Int!) {
    restoreUser(id: $id) {
      message
    }
  }
`;

export const DELETE_BOOK = gql`
  mutation deleteBook($slug: String!) {
    deleteBook(slug: $slug) {
      message
    }
  }
`;

export const RESTORE_BOOK = gql`
  mutation restoreBook($slug: String!) {
    restoreBook(slug: $slug) {
      message
    }
  }
`;

export const CREATE_CART_BOOK = gql`
  mutation createCart($bookId: Int!) {
    createCart(bookId: $bookId) {
      message
    }
  }
`;

export const REPORT_BOOK = gql`
  mutation createBookReport($bookId: Int!, $description: String!) {
    createBookReport(bookId: $bookId, description: $description) {
      message
    }
  }
`;

export const RATE_BOOK = gql`
  mutation createRating($ratingValue: Int!, $review: String!, $slug: String!) {
    createRating(ratingValue: $ratingValue, review: $review, slug: $slug) {
      message
    }
  }
`;

export const CREATE_PAYMENT = gql`
  mutation createPayment($input: [BookForPaymentIDs!]!) {
    createPayment(books: $input) {
      message
    }
  }
`;

export const REMOVE_BOOK_IN_CART = gql`
  mutation removeMyCart($cartId: Int!) {
    removeMyCart(cartId: $cartId) {
      message
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation updateProfile($firstname: String, $lastname: String, $address: String, $telephone: String, $profile: String) {
    updateProfile(firstname: $firstname, lastname: $lastname, address: $address, file: $profile, telephone: $telephone) {
      message
    }
  }
`;

export const CREATE_BOOK = gql`
  mutation createBook(
    $name: String!
    $tags: String
    $author: String!
    $price: Float!
    $category: String
    $paypalEmail: String
    $MoMoNumber: Long
    $AirtelMoneyNumber: Long
    $publishedCompany: String
    $summary: String!
    $madeIntoAnimation: Boolean!
    $image: String!
    $audio: String
    $video: String
    $book: String
  ) {
    createBook(
      name: $name
      tags: $tags
      author: $author
      madeIntoAnimation: $madeIntoAnimation
      price: $price
      category: $category
      summary: $summary
      paypalEmail: $paypalEmail
      MoMoNumber: $MoMoNumber
      AirtelMoneyNumber: $AirtelMoneyNumber
      publishedCompany: $publishedCompany
      image: $image
      audio: $audio
      video: $video
      book: $book
    ) {
      id
      name
      slug
      coverUrl
      audioUrl
      videoUrl
      bookUrl
      price
      category
      tags {
        tagName
      }
      author
      summary
      publishedCompany
      status
      createdAt
      updatedAt
      createdBy {
        id
        email
        firstname
        username
      }
    }
  }
`;

export const UPDATE_BOOK = gql`
  mutation updateBook(
    $slug: String!
    $name: String
    $tags: String
    $madeIntoAnimation: Boolean
    $author: String
    $price: Float
    $category: String
    $paypalEmail: String
    $MoMoNumber: Long
    $AirtelMoneyNumber: Long
    $publishedCompany: String
    $summary: String
    $image: String
    $audio: String
    $video: String
    $book: String
  ) {
    updateBook(
      slug: $slug
      name: $name
      tags: $tags
      author: $author
      madeIntoAnimation: $madeIntoAnimation
      price: $price
      category: $category
      summary: $summary
      paypalEmail: $paypalEmail
      MoMoNumber: $MoMoNumber
      AirtelMoneyNumber: $AirtelMoneyNumber
      publishedCompany: $publishedCompany
      image: $image
      audio: $audio
      video: $video
      book: $book
    ) {
      slug
    }
  }
`;

export const DELETE_PAYMENTS = gql`
  mutation deletePayment($bookId: Int!) {
    deletePayment(bookId: $bookId) {
      message
    }
  }
`;
